// The key a (family, weight, slant) triple is registered under.
//
// Lives in its own module because BOTH sides need it and must agree
// exactly: the UI registers a face under this key and the worker looks it
// up under the same one. A mismatch would be silent — the export would
// quietly fall back to the regular file, which looks like a styling bug
// rather than a plumbing one.
export function variantKey(font: string, bold: boolean, italic: boolean): string {
  return `${font}${bold ? "#b" : ""}${italic ? "#i" : ""}`;
}
